import { useState, useContext, useRef, useEffect } from 'react';
import Axios, { CancelTokenSource } from 'axios';
import { GetLogIn } from '../helpers/GetFromRestApi';
import { buildUserData } from '../helpers/BuildUserData';
import { UserContext } from '../contexts/ContextWrapper';
import { UserAdminItem } from '../interfaces/UserAdminItem';

export const useUserFetch = () => {
    const [isLoadingUser, setIsLoadingUser] = useState<boolean>(false);
    const { userContext, setUserContext } = useContext(UserContext);
    const cancelSource = useRef<CancelTokenSource | null>(null);

    useEffect(() => {
        return () => {
            if (cancelSource.current) {
                cancelSource.current.cancel('Component unmounted');
            }
        };
    }, []);

    const FetchUser = async (
        accessToken: string,
    ): Promise<UserAdminItem> => {
        setIsLoadingUser(true);
        cancelSource.current = Axios.CancelToken.source();
        try {
            // admin_login returns both the users.json entry and the Excel2Users.json
            // entry; either alone is enough to sign in. buildUserData flattens them into
            // the single userData the portal reads (union of domains/API, isExcel2Admin
            // gate). The raw Excel2 entry is kept in context for the Excel2 Accounts view.
            const login = await GetLogIn(accessToken, true, cancelSource.current.token);
            const user = buildUserData(login);
            setUserContext({
                userData: user,
                excel2User: login.Excel2User || null,
                adminMode: localStorage.getItem('adminMode') === 'true' && user.isRehngruppen,
            });
            setIsLoadingUser(false);
            return user;
        } catch (error) {
            if (!Axios.isCancel(error)) {
                console.error(error);
                setIsLoadingUser(false);
            }
            throw error;
        }
    };

    const HasUser = (): boolean => {
        return userContext.userData !== undefined;
    };

    return { FetchUser, HasUser, isLoadingUser };
};
